import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';

export default function KbdiTable(props) {
  const { regionData, monyr, areaType } = props;
  const { levelColors } = useContext(ColorsContext);
  
 const droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
    "Cape Cod",
    "Islands"
  ];

  const basins = [
    "Blackstone",
    "Boston Harbor",
    "Buzzards Bay",
    "Cape Cod",
    "Charles",
    "Chicopee",
    "Connecticut",
    "Deerfield",
    "Farmington",
    "French",
    "Housatonic",
    "Hudson",
    "Ipswich",
    "Islands",
    "Merrimack",
    "Millers",
    "Narragansett Bay",
    "Nashua",
    "North Coastal",
    "Parker",
    "Quinebaug",
    "Shawsheen",
    "South Coastal",
    "SuAsCo",
    "Taunton",
    "Ten Mile",
    "Westfield"
  ];

  const counties = [
    "Barnstable",
    "Berkshire",
    "Bristol",
    "Dukes",
    "Essex",
    "Franklin",
    "Hampden",
    "Hampshire",
    "Middlesex",
    "Nantucket",
    "Norfolk",
    "Plymouth",
    "Suffolk",
    "Worcester"
  ];

  var droughtAreas;
  switch (areaType) {
    case 'region':
      droughtAreas = droughtRegions;
      break;
    case 'basin':
       droughtAreas = basins;
      break;
    case 'county':
      droughtAreas = counties;
      break;
    default:
      console.log(`Bad areaType selection - ${areaType}`);
      droughtAreas = droughtRegions;
  }

  return (
    <>
    <table className="pcpnTable-container">
      <caption>
        {monyr} KBDI Summary
      </caption>
      <thead>
        <tr>
            <td colSpan="3">
                <table className="tableLegend-container">
                    <tbody>
                        <tr>
                            <td className="tableLegend-heading" colSpan="5">Shading indicates index severity level:</td>
                        </tr>
                        <tr>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
                            <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
        <tr>
          <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
          <th scope="col">{"Number of sites reporting"}</th>
          <th scope="col" abbr="Highest">{"Highest of station values"}</th>
         </tr>
      </thead>
      <tbody>
        {droughtAreas.map((rd, i) => (
          <tr key={i}>
            <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
            <td>{regionData[rd].count}</td>
            <td 
              style={{backgroundColor: levelColors[regionData[rd].level], color: regionData[rd].level !== 4 ? "black" : "white"}}
            >
              {regionData[rd].high !== -999 ? regionData[rd].high : '-'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    </>
  );
}